import { render, staticRenderFns } from "./Text.vue?vue&type=template&id=14632ae3"
import script from "./Text.vue?vue&type=script&setup=true&lang=js"
export * from "./Text.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/SysClass-Web-App/SysClass-Web-App/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('14632ae3')) {
      api.createRecord('14632ae3', component.options)
    } else {
      api.reload('14632ae3', component.options)
    }
    module.hot.accept("./Text.vue?vue&type=template&id=14632ae3", function () {
      api.rerender('14632ae3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/shared/components/buttons/Text.vue"
export default component.exports